<template>
    <b-modal
        ref="documentPreviewModal"
        cancel-variant="outline-secondary"
        size="xl"
        :ok-title="$t('Component(Button):close')"
        scrollable
        ok-only
        centered
        :title="file ? file.name : ''"
    >
        <Overlay :show="showOverlay">
            <object v-if="downloaded" :data="url" :type="file.mimeType" width="100%" :height="height">
                unable to display document
            </object>
        </Overlay>
    </b-modal>
</template>

<script>
import { BModal, BEmbed } from 'bootstrap-vue'
import {ProductApi, SupplyChain} from "@core/api";
import Overlay from "@core/components/common/Overlay";

export default {
    components: {BModal, BEmbed, Overlay},
    props: {
        type: {
            required: true,
        },
        file: {
            type: Object,
            default() {
                return {
                    id: null,
                    mimeType: 'application/pdf',
                    name: ''
                };
            }
        }
    },
    data() {
        return {
            showOverlay: true,
            downloaded: false,
            url: null,
            height: this.calculateHeight()
        }
    },
    mounted() {
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(document.body);
    },
    methods: {
        onResize() {
            this.height = this.calculateHeight();
        },
        show() {
            this.$refs.documentPreviewModal.show();
            this.download();
        },
        hide() {
            this.$refs.documentPreviewModal.hide();
        },
        download() {
            if (!this.file || !this.file.id) {
                return false;
            }
            SupplyChain.downloadDocument(this.type, this.file.id).then(response => {
                this.url = URL.createObjectURL(new Blob([response.data], {type: this.file.mimeType}));
                this.downloaded = true;
                this.showOverlay = false;
            }).catch((e) => {
                this.$emit('error', e);
            });
        },
        calculateHeight() {
            return (document.body.offsetHeight - 200) + 'px;';
        }
    },
}
</script>
